var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "pageForm1",
          staticClass: "page-form",
          attrs: { model: _vm.Business, rules: _vm.pageRules1 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Business")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BusinessName", label: "Business Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Business.BusinessName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Business, "BusinessName", $$v)
                          },
                          expression: "Business.BusinessName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BusinessRegistrationNumber",
                        label: "Business Registration Number",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Business.BusinessRegistrationNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.Business,
                              "BusinessRegistrationNumber",
                              $$v
                            )
                          },
                          expression: "Business.BusinessRegistrationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm2",
          staticClass: "page-form",
          attrs: { model: _vm.Location, rules: _vm.pageRules2 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Location")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BuildingNumber",
                        label: "Building Number",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.BuildingNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "BuildingNumber", $$v)
                          },
                          expression: "Location.BuildingNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BuildingName", label: "Building Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.BuildingName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "BuildingName", $$v)
                          },
                          expression: "Location.BuildingName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "UnitNumber", label: "Unit Number" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.UnitNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "UnitNumber", $$v)
                          },
                          expression: "Location.UnitNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "StreetType", label: "Street Type" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.StreetType,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "StreetType", $$v)
                          },
                          expression: "Location.StreetType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "StreetName", label: "Street Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.StreetName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "StreetName", $$v)
                          },
                          expression: "Location.StreetName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "City", label: "City" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.City,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "City", $$v)
                          },
                          expression: "Location.City",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm3",
          staticClass: "page-form",
          attrs: { model: _vm.Communication, rules: _vm.pageRules3 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Communication")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Telephone", label: "Telephone Number" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Communication.Telephone,
                          callback: function ($$v) {
                            _vm.$set(_vm.Communication, "Telephone", $$v)
                          },
                          expression: "Communication.Telephone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }